import React from 'react';
import BaseDivider from '@mui/material/Divider';
import c from 'classnames';

import { DividerProps } from './types';

const Divider: React.FC<React.PropsWithChildren<DividerProps>> = (props) => {
  const { className, color = 'border-divider', style, ...restProps } = props;

  return <BaseDivider className={c(color, className)} {...restProps} />;
};
export default React.memo(Divider);
